<template>
  <div>
    <div class="modal show fade modal-danger text-left" style="display: block;" v-if="show">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">Charges Details</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="$emit('hide')">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="">
              <div v-if="list.length" class="card-datatable table-responsive pt-0" >
                <table class="table ">
                  <thead class="thead-light">
                  <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Charge Type</th>
                    <th>Apply In Limits</th>
                    <th>Charges/Total</th>
                    <th>GW Charges/Total</th>
                  </tr>
                  </thead>
                  <tbody class="chargeTbody">
                  <template v-for="(row, index) in list">
                    <tr>
                      <td>
                        <button type="button" class="btn btn-sm btn-icon font-weight-bolder font-medium-1 rounded-circle btn-warning waves-effect waves-float waves-light" data-toggle="collapse"  :data-target="'#ch'+index" @click="accordionToShow  = index">
                          +
                        </button>
                      </td>
                      <td>{{row.charge.name}}</td>
                      <td>{{row.charge.type}}</td>
                      <td v-if="typeof row.charge_details?.apply_in_limits != 'undefined'">{{row.charge_details.apply_in_limits ? 'Yes':'No'}}</td>
                      <td v-else>-</td>
                      <td> <span class="badge badge-light-warning">{{row.type}}</span> {{parseFloat(row.type == 'percent'?row.charges:row.charges/100 ).toFixed(5)}} / {{row?.total ? parseFloat(row.total/100).toFixed(5) : ''}}</td>
                      <td><span class="badge badge-light-warning">{{row?.gw_type ?? row.type}}</span> {{parseFloat((row?.gw_type ?? row.type) == 'percent'?row.gw_charges:row.gw_charges/100 ).toFixed(5)}} / {{row?.gw_total ? parseFloat(row.gw_total/100).toFixed(5) : ''}}</td>
                    </tr>
                    <tr>
                      <td :colspan="list.length">
                        <div class="collapse" :id="'ch'+index">
                          <div class="card-body" v-if="row.charge_details?.charges">
                            <div class="card">
                              <table class="table border-dark  badge-glow" >
                                <thead>
                                <tr>
                                  <th v-for="(chargeVal,chargeKey) in row.charge_details?.charges[0] ?? []" :key="chargeKey" >{{chargeKey}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(chargeItem,chargeItemIndex) in row.charge_details?.charges ?? []" :key="chargeItemIndex" >
                                  <td v-for="(chargeVal,chargeKey) in chargeItem" :key="chargeKey">
                                    {{resolveChargeVal(chargeKey,chargeVal,row.charge_details)}}
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                          <div class="card-body" v-if="row.charge_details?.card_categories">
                            <div class="card">
                              <table class="table border-dark  badge-glow" >
                                <thead>
                                <tr>
                                  <th v-for="(chargeVal,chargeKey) in row.charge_details?.card_categories ?? []" :key="chargeKey" >{{chargeKey}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                  <td v-for="(chargeVal,chargeKey) in row.charge_details?.card_categories ?? []" :key="chargeKey">
                                    {{chargeVal}}
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                        </div>
                      </td>
                    </tr>
                  </template>
                  </tbody>
                </table>
              </div>
              <div class="card-body text-center text-primary" v-else>
                No Details Avaliable
              </div>
              <div class="col-12 d-flex mb-1  justify-content-center" v-if="loader">
                <div class="spinner-border text-primary"></div>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-between">
            <button type="button" class="btn btn-danger" data-dismiss="modal" @click="$emit('hide')">Close</button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>

export default {
  props: ['show', 'data', 'index'],
  data() {
    return {
      list: [],
      loader:false,
      accordionToShow: -1,
      // showModal: false,
    }
  },
  mounted() {
    // this.list = this.data
  },
  methods: {
    resolveChargeVal(chargeKey,chargeVal,chargeDetails){
      if(chargeDetails?.apply_in_limits){
        if(chargeKey.toUpperCase() == 'AMOUNT'){
          return chargeVal/100
        }
      }
      return chargeVal
    }
  },
  watch: {
    show() {
      let tData = this.$store.getters.getByKey(
          this.data.uuid+"_t_details"
      );
      if (tData) {
        this.list = tData?.data.transaction_charges
        return
      }
      this.loader =true
      this.makeRequest("post", "v1/get-transaction", {transactionDetail: 1,transactionId:this.data.uuid}, {}, false).then(
          callResponse => {
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                let data = []
                data = callResponse.response.data.data;
                if(data){
                  let responeDataToSave = {
                    data: data,
                    key: this.data.uuid+"_t_details"
                  };
                  this.$store.dispatch("setWithoutLocalStorage", responeDataToSave);
                  this.list = data.transaction_charges

                }

              }
            }
            this.loader= false
          }
      );

    },
    detailType() {

    }
  }
}
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}
</style>

